export default [
  // 找布易用户协议
  {
    path: '/zhaobuyi/license-user',
    name: 'ZhaobuyiLicenseUser',
    component: () => import('@/views/zhaobuyi/license-user.vue'),
  },
  {
    path: '/zhaobuyi/license-privacy',
    name: 'ZhaobuyiLicensePrivacy',
    component: () => import('@/views/zhaobuyi/license-privacy.vue'),
  },
];
